import { Component } from '@angular/core';

@Component({
  selector: 'app-hourglass-loader-course',
  standalone: true,
  imports: [],
  templateUrl: './hourglass-loader-course.component.html',
  styleUrl: './hourglass-loader-course.component.scss'
})
export class HourglassLoaderCourseComponent {

}
